export type PspSortingListFilter = {
  country: string;
  brand?: string[] | null;
}

export const DEFAULT_PSP_SORTING_FILTER: PspSortingListFilter = {
  country: '',
};
